import { render, staticRenderFns } from "./HomeDeliveries.vue?vue&type=template&id=73576785&scoped=true"
import script from "./HomeDeliveries.vue?vue&type=script&lang=js"
export * from "./HomeDeliveries.vue?vue&type=script&lang=js"
import style0 from "./HomeDeliveries.vue?vue&type=style&index=0&id=73576785&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73576785",
  null
  
)

export default component.exports